var exports = {
  "k": "container__YpJHmd",
  "I": "fullWidth__3jx5JM",
};

module.exports = exports;
